/*
 * hellopanda-share
 */
const HELLOPANDA_SHARE_ITEM = {
  init: function() {
    document.addEventListener('DOMContentLoaded', function() {
  
      const shares = document.querySelectorAll('.wp-block-hellopanda-share-item-block');
      shares.forEach(element => {
        
        element.addEventListener('click', () => {
          const platform = element.dataset.platform;
          const shareurl = element.dataset.shareurl;
          if (platform && shareurl) {
            window.open(`${shareurl}${encodeURIComponent(window.location.href)}`, '_blank');
          }
        });
      });
      
    });
  }
};
HELLOPANDA_SHARE_ITEM.init();